export const PAPER_CHROME_RADIUS_CLASS = 'rounded-[var(--paper-radius-chrome)]';
export const PAPER_CONTROL_RADIUS_CLASS = 'rounded-[var(--paper-radius-control)]';
export const PAPER_MOBILE_CONTROL_RADIUS_CLASS = 'mobile:rounded-[var(--paper-radius-control)]';
export const PAPER_ICON_BUTTON_CLASS =
  'inline-flex items-center justify-center rounded-[var(--paper-radius-control)]';
export const PAPER_CHROME_RADIUS_VALUE = 'var(--paper-radius-chrome)';
export const PAPER_CONTROL_RADIUS_VALUE = 'var(--paper-radius-control)';

// Paper icon scale: default for control glyphs, smaller steps for inline affordances.
export const PAPER_ICON_CLASS = 'h-5 w-5';
export const PAPER_ICON_COMPACT_CLASS = 'h-[17px] w-[17px]';
export const PAPER_ICON_SMALL_CLASS = 'h-4 w-4';
export const PAPER_ICON_TINY_CLASS = 'h-[14px] w-[14px]';
export const PAPER_ICON_MICRO_CLASS = 'h-3 w-3';
export const PAPER_ICON_DISPLAY_CLASS = 'h-8 w-8';
export const PAPER_ICON_SIZE = 20;
export const PAPER_ICON_COMPACT_SIZE = 17;
export const PAPER_ICON_SMALL_SIZE = 16;
export const PAPER_ICON_TINY_SIZE = 14;
export const PAPER_ICON_MICRO_SIZE = 12;
export const PAPER_ICON_DISPLAY_SIZE = 32;
export const PAPER_ICON_STROKE_WIDTH = 1.6;

export const PAPER_ICON_CONTROL_BEHAVIOR_CLASS =
  'border-0 bg-transparent p-0 text-[var(--fg-3)] cursor-pointer transition-colors duration-150 hover:bg-[var(--bg-alt)] hover:text-[var(--fg)] disabled:cursor-not-allowed disabled:opacity-40';
export const PAPER_ICON_CONTROL_CLASS =
  `${PAPER_ICON_BUTTON_CLASS} h-8 w-8 ${PAPER_ICON_CONTROL_BEHAVIOR_CLASS}`;
export const PAPER_ICON_CONTROL_COMPACT_CLASS =
  `${PAPER_ICON_BUTTON_CLASS} h-7 w-7 ${PAPER_ICON_CONTROL_BEHAVIOR_CLASS}`;
export const PAPER_ICON_CONTROL_MINI_CLASS =
  `${PAPER_ICON_BUTTON_CLASS} h-6 w-6 ${PAPER_ICON_CONTROL_BEHAVIOR_CLASS}`;
export const PAPER_ICON_CONTROL_MICRO_CLASS =
  `${PAPER_ICON_BUTTON_CLASS} h-[18px] w-[18px] ${PAPER_ICON_CONTROL_BEHAVIOR_CLASS}`;
export const PAPER_ICON_CONTROL_ACTIVE_CLASS =
  'bg-[var(--periwinkle-wash)] text-[var(--periwinkle)] hover:bg-[var(--periwinkle-wash)] hover:text-[var(--periwinkle)]';
export const PAPER_ICON_CONTROL_TOUCH_CLASS = 'mobile:h-10 mobile:w-10';

// Three-slot mobile header layout: a centered title flanked by minmax(0,1fr)
// side rails so the title position stays stable regardless of side-control width.
export const PAPER_MOBILE_HEADER_GRID_CLASS =
  'grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]';
export const PAPER_MOBILE_HEADER_TITLE_CAP_CLASS =
  'max-w-[var(--paper-mobile-header-title-max-width)]';
